import { CaseType } from './case-type';
 
export const CASES: CaseType[] = [
  { id: 11, type: 'A', name: 'Malattia', text: "Docente assente per malattia" , 
  hidden: false, settled: {label: "check se data fine definitiva", value: false, disable: false }, component: 'teacher', note:''},
  { id: 12, type: 'A', name: 'Ferie', text: "Docente che richiede un giorno di ferie" , 
  hidden: false, settled: {label: "tutto il giorno", value: true, disable: true }, component: 'teacher', note:''}, 
  { id: 15, type: 'A', name: 'Uscita didattica classe', text: "Classe che esce per attività didattiche, da qualche ora a più giorni", 
  hidden: false, settled: {label: "check se tutto il giorno", value: false, disable: false  }, component: 'special', note:''},
  { id: 16, type: 'A', name: 'Uscita didattica docente', text: "Docente che esce in accompagnamento di una classe, da qualche ora a più giorni" , 
  hidden: true, settled: {label: "check se tutto il giorno", value: false, disable: false  }, component: 'teacher', note:''},
  { id: 19, type: 'A', name: 'Assenza generica', text: "Assenza da non recuperare legata alle diverse tipologie permesse dalla legge e che non interessa distinguere" ,
  hidden: false, settled: {label: "check se tutto il giorno", value: false, disable: false  }, component: 'teacher', note:''},
  { id: 21, type: 'R', name: 'Permesso breve', text: "Permesso giornaliero di qualche ora che deve essere recuperato entro due mesi, tipicamente con le sostituzioni" ,
  hidden: false, settled: {label: "n.a.", value: false, disable: true  }, component: 'teacher', note:''},
  { id: 31, type: 'S', name: 'Entrata classe posticipata', text: "La classe entra una o più ore dopo l'inizio del proprio orario" ,
  hidden: false, settled: {label: "n.a.", value: false, disable: true  }, component: 'group', note:'EC'},
  { id: 32, type: 'S', name: 'Classe divisa', text: "La classe viene divisa e gli alunni distribuiti in altre classi" ,
  hidden: false, settled: {label: "n.a.", value: false, disable: true  }, component: 'group', note:'DC'},
  { id: 33, type: 'S', name: 'Uscita classe anticipata', text: "La classe esce una o più ore prima di aver terminato il proprio orario" ,
  hidden: false, settled: {label: "n.a.", value: false, disable: true  }, component: 'group', note:'UC'},
  { id: 41, type: 'P', name: 'Disponibile a pagamento', text: "Docente che da la disponibilità ad effettuare ore aggiuntive a pagamento, tipicamente usato per le sostituzioni" ,
  hidden: false, settled: {label: "n.a.", value: false, disable: true  }, component: 'teacher', note:''},
  { id: 51, type: 'S', name: 'Sostituzione', text: "Docente incaricato di sostituire un collega assente" ,
  hidden: true, settled: {label: "n.a.", value: false, disable: true  }, component: 'substitution', note:''}
];

/*
Memo for documentation
Field "component" meaning
teacher = enables use teacher component
group = enables use group component
special = used for case 15, uses first group comp and then teacher comp
substitution = only to distinguish from the others, non used in code, yet

*/


// WEBPACK FOOTER //
// c:/Dev/Angular/liceo/src/app/case-list.ts